import React, { FC, useLayoutEffect, useRef, useState } from 'react'
import styles from './file-preview.module.scss'

const FileExtension: FC<{ value: string }> = ({ value }) => {
  const labelRef = useRef<SVGTextElement | null>(null)
  const [position, setPosition] = useState<{ value: string; x: number; y: number }>()

  useLayoutEffect(() => {
    let active = true
    const measure = () => {
      if (!active || !labelRef.current) return
      const context = document.createElement('canvas').getContext('2d')
      if (!context) return
      const font = window.getComputedStyle(labelRef.current)
      context.font = `${font.fontWeight || '600'} ${font.fontSize || '15px'} ${font.fontFamily || 'Rosatom'}`
      const bounds = context.measureText(value)
      const { actualBoundingBoxLeft: left, actualBoundingBoxRight: right } = bounds
      const { actualBoundingBoxAscent: ascent, actualBoundingBoxDescent: descent } = bounds
      if (![left, right, ascent, descent].every(Number.isFinite)) return
      setPosition({
        value,
        x: 20 + (left - right) / 2,
        y: 20 + (ascent - descent) / 2,
      })
    }
    measure()
    if (document.fonts) {
      document.fonts.ready.then(measure)
      document.fonts.addEventListener('loadingdone', measure)
    }
    return () => {
      active = false
      document.fonts?.removeEventListener('loadingdone', measure)
    }
  }, [value])

  const measured = position?.value === value ? position : undefined
  return (
    <svg className={styles.fileExtension} viewBox="0 0 40 40" aria-hidden="true" focusable="false">
      <text
        ref={labelRef}
        x={measured ? measured.x : 20}
        y={measured ? measured.y : 20}
        textAnchor={measured ? 'start' : 'middle'}
        dominantBaseline={measured ? 'alphabetic' : 'central'}
        fill="currentColor"
      >
        {value}
      </text>
    </svg>
  )
}

export default FileExtension
